import Vue from "vue";
import Router from "vue-router";
//import Landing from "./components/auth/landing.vue";
//import Landing from "./components/libs/home_lib.vue";
import Profile from "./components/auth/profile.vue";
import Signin from "./components/auth/signin.vue";
import Signup from "./components/auth/signup.vue";
import AuthGuard from "./AuthGuard";
// import MetaGuard from "./MetaGuard";
//import HomeClub from "./components/club_management/home_club.vue";

// Admin components
import UserList from "./components/admin/user_list.vue";

// OGuru Shop
import shopList from "./components/shop/shop_list.vue";
// import Home from './components/shop/Home'
// import Shop from './components/shop/Shop'
// import Product from "./components/shop/Product";
// import Blog from './components/shop/Blog'
// import Post from './components/shop/Post'
// import Layout from './components/shop/Layout'
import VendorsList from "./components/data_management/vendors_list.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      name: "landing",
      component: shopList
    },
    {
      path: "/auth/user_profile",
      name: "Profile",
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: "/auth/signin",
      name: "Signin",
      component: Signin
    },
    {
      path: "/auth/signup",
      name: "Signup",
      component: Signup
    },
    {
      path: "/admin/user_list",
      name: "UserList",
      component: UserList,
      beforeEnter: AuthGuard
    },
    {
      path: "/shop/shop_list",
      name: "shopList",
      component: shopList
      //  ,beforeEnter: AuthGuard
    },
    {
      path: "/product/:id",
      name: "Product",
      component: () => import("./components/shop/Product.vue")
      //  ,beforeEnter: AuthGuard
    },
    {
      path: "/vendors/vendor",
      name: "Vendors",
      component: VendorsList
    }
  ]
});
